/**
 * Ordinamento deterministico degli stage pipeline.
 *
 * Postgres non garantisce l'ordine a parità di sort_order: pipeline con stage
 * duplicati (es. tutti a 0) venivano restituite in sequenza diversa ad ogni
 * fetch, rimescolando le colonne del Kanban. Questi helper garantiscono un
 * ordine stabile lato client e progressivi corretti in creazione.
 */

interface StageOrderable {
  id: string;
  sort_order: number;
  created_at?: string;
}

/** Ordina per sort_order, con tie-break su created_at e id. Non muta l'input. */
export function sortByStageOrder<T extends StageOrderable>(items: T[]): T[] {
  return [...items].sort((a, b) => {
    if (a.sort_order !== b.sort_order) return a.sort_order - b.sort_order;
    const aCreated = a.created_at || '';
    const bCreated = b.created_at || '';
    if (aCreated !== bCreated) return aCreated < bCreated ? -1 : 1;
    return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
  });
}

/** Prossimo sort_order per un nuovo stage: max esistente + 1, 0 se vuoto. */
export function nextStageSortOrder(stages: StageOrderable[]): number {
  if (stages.length === 0) return 0;
  return Math.max(...stages.map(s => s.sort_order)) + 1;
}
